import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, path = '', image }) => {
    const siteUrl = 'https://www.abducaofilmes.com.br';
    const defaultDescription = 'Abdução Filmes - Produtora de cinema independente de Belo Horizonte, MG. Curtas-metragens premiados em festivais internacionais.';
    const defaultImage = `${siteUrl}/logo512.png`;

    const fullTitle = title ? `${title} | Abdução Filmes` : 'Abdução Filmes - Cinema Independente';
    const desc = description || defaultDescription;
    const url = `${siteUrl}${path}`;
    const img = image || defaultImage;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={img} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={img} />
        </Helmet>
    );
};

export default SEO;
